module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-row', {
    staticClass: "page-title"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b917d32","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageTitle.vue
// module id = 779
// module chunks = 0